import { api } from '../../config/ApiConfig';

export const Matches = {
  load: () => api.get('/v1/matches?included=users.city,users.city.state,users'),
  delete: (matchId) => api.delete(`/v1/matches/${matchId}`),
  loadMessages: (matchId, page) => api.get(`/v1/matches/${matchId}/messages?page[number]=${page}&page[size]=15`),
  sendMessage: (matchId, contentData) => api.post(`/v1/matches/${matchId}/messages`, contentData)
}